import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { DeliveryIndicatorGraphContainer } from '@grandvisionhq/www-next/slot-components/DeliveryIndicatorGraphContainer'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import OpticianForm from '../../../components/forms/Optician'
import { composePDP } from '../../../components/hocs/compose-pdp'
import {
  getDeliveryIndicatorConfig,
  getSpecifications,
  graphPromoteInstallmentsConfiguration,
} from '../../../configuration'
import { deliveryResolverFactory } from '../../../util/delivery-resolver-factory'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
  BeforeUsps: () => (
    <DeliveryIndicatorGraphContainer deliveryResolverFactory={deliveryResolverFactory} />
  ),
  Configurator: (props) => (
    <RxGlassesConfiguratorGraphContainer {...props} opticianForm={OpticianForm} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { productType } = props.product
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType)

  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={specificationConfiguration}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
